import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { lenis } from "../base/scroll";
import { headerLotties } from "../components/header-logo";
import { inner } from "../utils/variables";

let headerVisible = false;
export default function initHeader() {
    const headerStatic = document.querySelector<HTMLElement>(".header--static");
    const header = document.querySelector<HTMLElement>(".header");
    if (!headerStatic || !header) return;

    let isInsideStaticHeader = true;

    ScrollTrigger.create({
        trigger: "body",
        start: "top-=30 top",
        end: `top+=${inner.h} top`,
        once: false,

        onEnter: () => (isInsideStaticHeader = true),
        onLeaveBack: () => (isInsideStaticHeader = false),
        onEnterBack: () => (isInsideStaticHeader = true),
        onLeave: () => (isInsideStaticHeader = false),
    });

    header.classList.add("header--at-top");

    lenis.on("scroll", lenis => {
        if (lenis.scroll <= 40) {
            header.classList.add("header--at-top");
        } else {
            header.classList.remove("header--at-top");
        }

        if (isInsideStaticHeader) {
            toggleFixedHeaderHide("add");
        } else {
            if (lenis.velocity > 1 && headerVisible) {
                toggleFixedHeaderHide("add");
            } else if (lenis.velocity < -1 && !headerVisible) {
                toggleFixedHeaderHide("remove");
            }
        }
    });

    headerInAnimation(headerStatic);
}

function headerInAnimation(headerStatic: HTMLElement) {
    const children = headerStatic.querySelectorAll<HTMLElement>(".header__nav .header__nav__list__item__trigger, .header__subnav__list > *");

    gsap.to(headerStatic, {
        opacity: 1,
    });

    gsap.fromTo(
        children,
        {
            yPercent: 45,
        },
        {
            yPercent: 0,
            stagger: 0.03,
            ease: "power4.inOut",
            duration: 1.4,

            onComplete: () => {
                gsap.set(children, { clearProps: "yPercent" });
            },
        }
    );

    const headerNav = headerStatic.querySelector<HTMLElement>(".header__nav");
    gsap.fromTo(
        [children, headerNav],
        {
            opacity: 0,
        },
        {
            opacity: 1,
            ease: "power4.inOut",
            duration: 1.4,
        }
    );

    setTimeout(() => {
        headerLotties.forEach(headerLottie => headerLottie.play());
    }, 100);
}

export function toggleFixedHeaderHide(action: string) {
    const headerFixed = document.querySelector<HTMLElement>(".header--fixed");
    if (!headerFixed) return;

    headerFixed.classList[action]("header--fixed--hide");
    headerVisible = action === "remove";
}
